<template>
  <div class="PresentationInfo">

    <presentation-breadcrumbs :items="[{text: 'Info'}]">
    </presentation-breadcrumbs>

    <presentation-toolbar :presentation="presentation">
    </presentation-toolbar>

    <v-alert v-if="presentation.is_internal_use_only"
             type="warning"
             flat
             tile
             class="my-0">
      <strong class="text-uppercase">For Internal Use Only</strong>. It is not to be shown to or shared with customers.
    </v-alert>

    <presentation-info-card :presentation="presentation">
    </presentation-info-card>

    <presentation-vault-card :presentation="presentation">
    </presentation-vault-card>

    <presentation-access-card :presentation="presentation">
    </presentation-access-card>

    <presentation-permissions-card :presentation="presentation">
    </presentation-permissions-card>

    <presentation-sharing-card :presentation="presentation">
    </presentation-sharing-card>

    <presentation-settings-card :presentation="presentation">
    </presentation-settings-card>
  </div>
</template>
<style lang="scss">
.PresentationInfo {
  table tbody tr td:nth-child(1) {
    width: 30%;
  }

  .v-list {
    background: none;
  }

  .v-list-item {
    padding-left: 0;
  }
}
</style>
<script>
import {mapGetters} from 'vuex';
import StatusChip from '../../components/StatusChip';
import PresentationToolbar from './components/PresentationToolbar';
import PresentationBreadcrumbs from './components/PresentationBreadcrumbs';
import PresentationIcon from './components/PresentationIcon';
import PresentationInfoCard from './components/PresentationInfoCard';
import PresentationAccessCard from './components/PresentationAccessCard';
import PresentationPermissionsCard from './components/PresentationPermissionsCard';
import PresentationSharingCard from './components/PresentationSharingCard';
import PresentationPublishingCard from './components/PresentationPublishingCard';
import PresentationSettingsCard from './components/PresentationSettingsCard';
import PresentationVaultCard from './components/PresentationVaultCard';

export default {
  components: {PresentationVaultCard, PresentationSettingsCard, PresentationPublishingCard, PresentationSharingCard, PresentationPermissionsCard, PresentationAccessCard, PresentationInfoCard, PresentationIcon, PresentationBreadcrumbs, PresentationToolbar, StatusChip},
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  metaInfo() {
    this.$store.commit('setTitle', this.presentation.name);
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Presentations', exact: true, to: {name: 'presentations'},},
        {text: 'Show'},
      ],
    }
  },
  computed: {
    ...mapGetters([
      'shareTemplates',
      'team',
      'users',
    ]),
  },
}
</script>
